import { useParams } from "react-router-dom";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import { RenterDashboard } from "./components/renter-dashboard";
import { RenterDashboardProvider } from "./components/renter-dashboard/RenterDashboard.provider";
import Dashboard from "../../common/components/layout/Dashboard";

function RenterDetailsPage() {
    const { renterId } = useParams()

    return (
        <ToastProvider>
            <Dashboard>
                <RenterDashboardProvider renterId={renterId || ''}>
                    <RenterDashboard />
                </RenterDashboardProvider>
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}

export default RenterDetailsPage